import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "charts-view" };
const _hoisted_2 = { class: "content-container" };
const _hoisted_3 = {
    key: 0,
    class: "content-card"
};
const _hoisted_4 = {
    key: 1,
    class: "content-card"
};
const _hoisted_5 = {
    key: 2,
    class: "content-card"
};
const _hoisted_6 = {
    key: 0,
    class: "content-card"
};
const _hoisted_7 = {
    key: 1,
    class: "content-card"
};
const _hoisted_8 = {
    key: 2,
    class: "content-card"
};
const _hoisted_9 = {
    key: 3,
    class: "charts-grid"
};
import { ref, onMounted, onUnmounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useToast } from "@/shared/composables/useToast";
import { ChartUseCases } from "@/application/use-cases/ChartUseCases";
import ToucanWidget from "@/presentation/components/charts/ToucanWidget.vue";
import DashboardLoadingState from "@/presentation/components/dashboard/DashboardLoadingState.vue";
import DashboardErrorState from "@/presentation/components/dashboard/DashboardErrorState.vue";
import DashboardOnboardingIncomplete from "@/presentation/components/dashboard/DashboardOnboardingIncomplete.vue";
import DashboardNoData from "@/presentation/components/dashboard/DashboardNoData.vue";
import { useI18n } from "vue-i18n";
import { useLogger } from "@/shared/composables/useLogger";
import { useAccountInfo } from "@/shared/composables/useAccountInfo";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Charts',
    setup(__props) {
        const { t } = useI18n();
        const logger = useLogger();
        const router = useRouter();
        const route = useRoute();
        const { showSuccess } = useToast();
        const chartUseCases = new ChartUseCases();
        const { isAccountActive, hasAccountInfo, error: accountError, isLoading: isLoadingAccount, fetchAccountInfo, } = useAccountInfo();
        const charts = ref([]);
        const isLoading = ref(true);
        const error = ref(null);
        const hasData = ref(true);
        async function loadCharts() {
            isLoading.value = true;
            error.value = null;
            try {
                const result = await chartUseCases.loadCharts();
                charts.value = result.charts;
                hasData.value = result.hasData;
            }
            catch (err) {
                logger.debug("Failed to load charts:", err);
                error.value = err instanceof Error ? err.message : "Unknown error";
            }
            finally {
                isLoading.value = false;
            }
        }
        /**
         * Retry initialization when the user clicks the retry button
         */
        async function retryInitialization() {
            await fetchAccountInfo();
            if (isAccountActive.value) {
                await loadCharts();
            }
        }
        onMounted(async () => {
            // First fetch account info to check onboarding status
            await fetchAccountInfo();
            // Check for invite parameter and show success message
            const inviteParam = route.query.invite;
            if (inviteParam === "1") {
                // Get organization name from organizationCache
                const orgName = localStorage.getItem("organizationCache") || "organisation";
                showSuccess(t("dashboard.transactions.inviteSuccess", { organizationName: orgName }));
                // Remove invite parameter from URL
                const newQuery = { ...route.query };
                delete newQuery.invite;
                await router.replace({ query: newQuery });
            }
            // Only load charts if account is active
            if (isAccountActive.value) {
                await loadCharts();
            }
        });
        onUnmounted(() => {
            chartUseCases.cleanup();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (_unref(isLoadingAccount))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createVNode(DashboardLoadingState)
                        ]))
                        : (_unref(accountError) !== null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createVNode(DashboardErrorState, {
                                    title: _ctx.$t('dashboard.loadAccountInfoError.title'),
                                    message: _ctx.$t('dashboard.loadAccountInfoError.message'),
                                    "retry-label": _ctx.$t('dashboard.loadAccountInfoError.retry'),
                                    onRetry: retryInitialization
                                }, null, 8 /* PROPS */, ["title", "message", "retry-label"])
                            ]))
                            : (_unref(hasAccountInfo) && !_unref(isAccountActive))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    _createVNode(DashboardOnboardingIncomplete, {
                                        title: _ctx.$t('dashboard.onboardingIncomplete.title'),
                                        message: _ctx.$t('dashboard.onboardingIncomplete.message'),
                                        "action-label": _ctx.$t('dashboard.onboardingIncomplete.action'),
                                        onAction: _cache[0] || (_cache[0] = ($event) => (_unref(router).push('/onboarding')))
                                    }, null, 8 /* PROPS */, ["title", "message", "action-label"])
                                ]))
                                : (_unref(isAccountActive))
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                        (isLoading.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                                _createVNode(DashboardLoadingState, {
                                                    message: _ctx.$t('dashboard.charts.loadingCharts')
                                                }, null, 8 /* PROPS */, ["message"])
                                            ]))
                                            : (error.value !== null)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                                    _createVNode(DashboardErrorState, {
                                                        title: _ctx.$t('dashboard.charts.loadError.title'),
                                                        message: _ctx.$t('dashboard.charts.loadError.message'),
                                                        "retry-label": _ctx.$t('dashboard.charts.loadError.retry'),
                                                        onRetry: loadCharts
                                                    }, null, 8 /* PROPS */, ["title", "message", "retry-label"])
                                                ]))
                                                : (!hasData.value)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                                        _createVNode(DashboardNoData, {
                                                            title: _ctx.$t('dashboard.charts.noData.title'),
                                                            message: _ctx.$t('dashboard.charts.noData.message')
                                                        }, null, 8 /* PROPS */, ["title", "message"])
                                                    ]))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(charts.value, (chart) => {
                                                            return (_openBlock(), _createBlock(ToucanWidget, {
                                                                key: chart.id,
                                                                chart: chart,
                                                                "hide-actions": charts.value.length === 1,
                                                                class: _normalizeClass({ 'col-span-2': chart.cols === 2 || charts.value.length === 1 })
                                                            }, null, 8 /* PROPS */, ["chart", "hide-actions", "class"]));
                                                        }), 128 /* KEYED_FRAGMENT */))
                                                    ]))
                                    ], 64 /* STABLE_FRAGMENT */))
                                    : _createCommentVNode("v-if", true)
                ])
            ]));
        };
    }
});
